import React from 'react';

import { Icon } from '@/components/shared/element/icons';
import { Text } from '@/components/shared/element/text';
import { Flex } from '@/components/shared/layout/flex';
import { Grid } from '@/components/shared/layout/grid';
import { IIcon } from '@/types/shared';

export interface DealerPanelContentLabelWithIconProps {
  icon?: IIcon;
  label: string;
  isLink?: boolean;
}

export const DealerPanelContentLabelWithIcon: React.FunctionComponent<
  DealerPanelContentLabelWithIconProps
> = (props: DealerPanelContentLabelWithIconProps) => {
  return props.isLink ? (
    <Grid
      css={{
        gridTemplateColumns: props.icon ? '20px 1fr' : '1fr',
      }}
      columnGap="2"
    >
      {!!props.icon && <Icon icon={props.icon} size="sm" color="icon-red" />}
      <Text
        as="p"
        css={{ maxWidth: 'calc(100% - $size-5)' }}
        variant="text-current"
        lines={props.isLink ? '1' : undefined}
      >
        {props.label}
      </Text>
    </Grid>
  ) : (
    <Flex columnGap="2">
      {!!props.icon && <Icon icon={props.icon} size="sm" color="icon-red" />}
      <Text
        as="p"
        css={{ maxWidth: 'calc(100% - $size-5)' }}
        variant="text-current"
        lines={props.isLink ? '1' : undefined}
      >
        {props.label}
      </Text>
    </Flex>
  );
};

DealerPanelContentLabelWithIcon.displayName = 'DealerPanelContentLabelWithIcon';
